import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { Modal } from 'antd'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  Button,
  Col,
  ContactForm,
  ContentBody,
  Dropdown,
  Menu,
  MenuItem,
  Row,
  Table
} from '../../../../core/components'
import { ContactWithId, Pagination } from '../../../../entities'
import useCustomerContactCreate from '../../../../services/mutations/useCustomerContactCreate'
import useCustomerContactDelete from '../../../../services/mutations/useCustomerContactDelete'
import useCustomerContactUpdate from '../../../../services/mutations/useCustomerContactUpdate'
import useCustomerContacts from '../../../../services/queries/customer/useCustomerContacts'
import { phoneNumberFormat } from '../../../../utils/format/phoneNumberFormat'

const contactDefaultValues = {
  id: '',
  name: '',
  role: '',
  phoneNumber: '',
  cellNumber: '',
  email: '',
  observation: '',
  gender: ''
}

export const ContactsTab = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isEditModalVisible, setIsEditModalVisible] = useState(false)
  const [form, setForm] = useState<ContactWithId>(contactDefaultValues)
  const { id }: any = useParams()
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const { data, error, isLoading }: any = useCustomerContacts({
    ...pagination,
    id
  })
  const { mutate } = useCustomerContactCreate()
  const { mutate: updateContact } = useCustomerContactUpdate()
  const { mutate: deleteContact } = useCustomerContactDelete()

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const showModal = () => {
    setIsModalVisible(true)
  }

  const showEditModal = () => {
    setIsEditModalVisible(true)
  }
  const handleEdit = (row: any) => {
    setForm(row)
    showEditModal()
  }

  const handleOk = () => {
    mutate({ contacts: [form], id })
    setForm(contactDefaultValues)
    setIsModalVisible(false)
  }

  const handleEditOk = () => {
    updateContact({ ...form, id })
    setForm(contactDefaultValues)
    setIsEditModalVisible(false)
  }

  const handleDelete = (row: any) => {
    deleteContact({ sequence: row.sequence, id })
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }
  const handleEditCancel = () => {
    setIsEditModalVisible(false)
  }

  const ActionMenu = ({ row }: any) => {
    return (
      <Row gutter={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <Col>
          <Dropdown
            overlay={
              <Menu>
                <MenuItem
                  onClick={() => handleEdit(row)}
                  key="1"
                  icon={<EditOutlined style={{ color: '#1890ff' }} />}
                >
                  Editar
                </MenuItem>
                <MenuItem
                  onClick={() => handleDelete(row)}
                  key="3"
                  icon={<DeleteOutlined style={{ color: '#f5222d' }} />}
                >
                  Excluir
                </MenuItem>
              </Menu>
            }
          >
            <Button>
              <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
      </Row>
    )
  }

  const columns = useMemo(
    () => [
      {
        title: 'Nome',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email'
      },
      {
        title: 'Telefone 1',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
        render: (value: any) => {
          return phoneNumberFormat(value)
        }
      },
      {
        title: 'Telefone 2',
        dataIndex: 'cellNumber',
        key: 'cellNumber',
        render: (value: any) => {
          return phoneNumberFormat(value)
        }
      },
      {
        title: 'Função',
        dataIndex: 'role',
        key: 'role'
      },
      {
        title: 'Ações',
        dataIndex: '#',
        key: 'action',
        // eslint-disable-next-line react/display-name
        render: (_: any, obj: any) => <ActionMenu row={obj} />
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <>
      <ContentBody>
        <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
          Novo
        </Button>
        <Modal
          title="Novo Contato"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Cadastrar"
          cancelText="Cancelar"
          centered
        >
          <ContactForm value={form} setValue={setForm} />
        </Modal>
        <Modal
          title="Editar Contato"
          visible={isEditModalVisible}
          onOk={handleEditOk}
          onCancel={handleEditCancel}
          okText="Atualizar"
          cancelText="Cancelar"
          centered
        >
          <ContactForm value={form} setValue={setForm} />
        </Modal>
        <div style={{ height: 20 }} />
        <Table
          columns={columns}
          dataSource={data?.data}
          bordered
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: data?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
        />
      </ContentBody>
    </>
  )
}
